import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators,FormArray } from '@angular/forms';
declare var $: any;
import { AppUtilityService } from 'src/app/common/app-utility.service';
import { environment, countryCodes } from 'src/environments/environment.prod';
import { EnglishTranslation, MalayTranslation } from '../app.constants';


@Component({
  selector: 'app-make-appointment-contact-details',
  templateUrl: './make-appointment-contact-details.component.html',
  styleUrls: ['./make-appointment-contact-details.component.scss']
})
export class MakeAppointmentContactDetailsComponent implements OnInit {
  product:string
  productDescription:string 
  mobileMaxInput : Number = 48
  mobileMinInput : Number = 1
  mobileNumberPattern = this.AppUtility.mobileNumberPattern('60');
  CountryCodes = countryCodes;
  PreferredBranch:any
  textContent: any;
  langTranslation: string = 'en-us';

  dataa:any[]=[]
  pb:any[]=[]

  constructor(
    private connect: ConnectRestService,
    private formBuilder: FormBuilder,
    private router: Router,    
    private activatedRoute: ActivatedRoute,
    private AppUtility : AppUtilityService
  ) { 
    this.activatedRoute.queryParams
    .subscribe(params =>
      { 
        if (params["product"]) sessionStorage.setItem("currentProduct", params["product"]);
        
        if (params['lang']) {
          this.textContent = params['lang'] == 'en-us' || params['lang'] == undefined ? EnglishTranslation.OTPScreen : MalayTranslation.OTPScreen;
          this.langTranslation = params['lang'];
          sessionStorage.language = params['lang'];
        }

        localStorage.setItem('URLParam', JSON.stringify({"Product": params["product"],"ProductDescription":  params['productDescription'], "Source1":params['source1'],"Source2":params['source2']}));
        localStorage.setItem('SavedQueryParams', JSON.stringify(params));
    })
  }

  @HostListener('document:keypress', ['$event'])
  onKeyPress(elemValue){
    if(elemValue.target.id==='applicant_mobile_number'){
      return this.AppUtility.mobileNumberValidation(elemValue.key)
    }else if(elemValue.target.type ==='text' || elemValue.target.type ==='email'){
      return this.AppUtility.characterValidation(elemValue.key)
    } 
  }

  ApptInfo: FormGroup;

  onSubmit() {
    if ($("#obaoform").valid()) {
      // (Begin) CJT 02Jun2020 - Send S0150 Service and Redirect to Thank You Screen on clicking Next Button
      // (Begin) CJT 05Jun2020 - Added AccountDetails for S0150
      var locStorage=JSON.parse(localStorage.getItem("URLParam"))
      var data = {
        ApplicantName: this.ApptInfo.value.ApplicantName,
        CompanyName: this.ApptInfo.value.CompanyName,
        EmailAddress: this.ApptInfo.value.EmailAddress,
        mobileNumber: this.ApptInfo.value.countryCode+'-'+this.ApptInfo.value.MobileNumber,
        ProductCode: locStorage.Product,
        ProductDescription: locStorage.ProductDescription,
        //(Begin) add new attributeds
        BusinessLocation: this.ApptInfo.value.BranchLocation,
        PreferredOCBCBranch:this.ApptInfo.value.PreferredBranch,
        UEN:this.ApptInfo.value.UEN,
        Source1:locStorage.Source1,
        Source2:locStorage.Source2
//(End) CW 23APR2021
      }

      this.restConnect(data);
      // (End) CJT 02Jun2020 
    }
  }

  // (Begin) CJT 02Jun2020 to call connectRest Service Function

  async restConnect(data) {
    // existing
    var RequestID = "S0150";
    var responseData = await this.connect.connectRest(data, RequestID, '');
    
    // routing for dropoff
    // var reqId = "R0000";
    // var respData = await this.connect.connectRest('', reqId, '');

    // routing based on response
    if (responseData.Status == "Success") {
      this.router.navigate(['/make-appointment-thank-you']);
    } else {

    //  console.log(data);
    }
  }

  // (End) CJT 02Jun2020

  //(Begin) 23Apr2021 retreve branch location
async retrieveBranchCode (){
  var locStorage=JSON.parse(localStorage.getItem("URLParam"));

  var responseData = await this.connect.connectRest({ Keys:[{Code:"ALL"}], ProductCode: locStorage.Product },"R0500","")

  if(responseData.Status == "Success"){
    
    this.dataa = responseData['LocationList'];
  }

}
//(End) CW 23Apr2021
  //(Begin) 23Apr2021 get preferred branch
public setFormData(bl) {
  var c=this.ApptInfo.get("BranchLocation")

 var v=[]
 //filter preferedBranchList based on the state selected
    v=this.dataa.filter(m=>m.State==bl);
 
    //console.log("d"+JSON.stringify(this.dataa))
    this.pb=v[0].PreferredBranchList;
 
}
//(End) CW 23Apr2021
  // testing
  ngOnInit() {
    //GET product info 
    var locStorage=JSON.parse(localStorage.getItem("URLParam"));
    this.product=locStorage.Product;
    this.productDescription = locStorage.ProductDescription
    this.retrieveBranchCode();
    this.textContent = this.langTranslation == 'en-us' || this.langTranslation == undefined ? EnglishTranslation.AppointmentScreen : MalayTranslation.AppointmentScreen;

    // (Begin) CJT 02Jun2020 - Add the FormGroup
    // CJT 08Jun2020 - Added Validators
    
    this.ApptInfo = this.formBuilder.group({
      ApplicantName: ['', Validators.required],
      CompanyName: ['', Validators.required],
      EmailAddress: ['', [Validators.required, Validators.pattern(environment.emailPatternHTML5)]],
      MobileNumber: ['', [Validators.required, Validators.pattern(this.mobileNumberPattern)]],
      countryCode: ['60'],
      BranchLocation:  ['', Validators.required],
        PreferredBranch: ['', Validators.required],
        UEN: ['', Validators.required]

    })
    // (End) CJT 02Jun2020 


    $(document).ready(function () {

      /*       $("#applicant_mobile").keydown(function(e){
              var oldvalue = $(this).val();
              var field = this;
              setTimeout(function (){
                if(field.value.indexOf('+60') !== 0){
                  $(field).val(oldvalue);
                }
              },1)
            }); */

            /*
      *** removed by Sonny
      *** created centralized fucntion for resuable components
            $("#countryCode").change(function () {
              $("#applicant_mobile_number").val("");
              var len = $(this).val().length;
              var max_length = 50-len;
            //  console.log(max_length)
              if ($("#countryCode").val() == "60") {
                $("#applicant_mobile_number").attr('maxlength', 10);
                $("#applicant_mobile_number").attr('pattern', "^(1)[0-46-9]-*[0-9]{7,8}$");
              }
              else {
                $("#applicant_mobile_number").attr('maxlength', max_length);
                $("#applicant_mobile_number").removeAttr('pattern');
              }
            });

            $("#applicant_mobile_number").change(function () {
              if ($("#countryCode").val() == "60") {
                $("#applicant_mobile_number").attr('maxlength', 10);
                $("#applicant_mobile_number").attr('pattern', "^(1)[0-46-9]-*[0-9]{7,8}$");
              }
            });

      var countryCode = $("#countryCode");
      var numberPhone = $("#applicant_mobile_number");
      numberPhone.keyup(function () {
        $("#applicant_mobile_number_hidden").val(countryCode.val() + numberPhone.val());
      //  console.log($("#applicant_mobile_number_hidden").val());
      });
      */

//DCI update (15/7/2020): Disable keypress enter or other to navigate page

     $("form").bind("keypress",function(e){
      if(e.keyCode == 13){
        return false;
      }
    })

      $("#obaoform").validate({
        rules: {
          company_name: {
            required: true
          },
          applicant_name: {
            required: true
          },
          applicant_mobile_number: {
            required: true,
            number: true
          },
          applicant_email: {
            required: true
          }
        },
        messages: {
          company_name: {
            required: "Please enter company name"
          },
          applicant_name: {
            required: "Please enter applicant name"
          },
          applicant_mobile_number: {
            required: "Please enter your mobile number",
            number: "Please enter a valid number",
            pattern: "Please enter valid format"
          },
          applicant_email: {
            required: "Please enter your email address",
            email: "Please enter valid email address",
            pattern: "Please enter valid email address"
          }

        }, errorPlacement: function (error, element) {
          if (element.attr("name") == "company_name") {
            error.appendTo($("#company_name_error_container"));
          }
          if (element.attr("name") == "applicant_name") {
            error.appendTo($("#applicant_name_error_container"));
          }
          if (element.attr("name") == "applicant_mobile_number") {
            error.appendTo($("#applicant_mobile_error_container"));
          }
          if (element.attr("name") == "applicant_email") {
            error.appendTo($("#applicant_email_error_container"));
          }
        },
        submitHandler: function (form) {

        }
      });
    });
    this.onCountryCodeChange(this.ApptInfo.value.countryCode)
  }

  validateChar(event){
    var value = event.target.value;
    var control = event.target.getAttribute('formcontrolname');
    if(!this.AppUtility.stringValidation(value)){
      this.ApptInfo.get(control).setValue(this.AppUtility.filterInvalidCharacters(value));
    }
  }

  onCountryCodeChange(elemValue){
    var respValue = this.AppUtility.mobileNumberMinMaxLength(elemValue)
    this.mobileMaxInput = respValue.max
    this.mobileMinInput = respValue.min

    // Added by CJ for Mobile Number Pattern 14Jul2020
    this.mobileNumberPattern = this.AppUtility.mobileNumberPattern(elemValue);
    this.ApptInfo.get("MobileNumber").setValidators([Validators.required,Validators.pattern(this.mobileNumberPattern)]);
    $('#applicant_mobile_number').blur()
  }

  resetMobileValidation(){
    if(this.ApptInfo.controls['MobileNumber'].dirty){
    $('#applicant_mobile_number').valid()
    }
  }

  previousClick() {
    var params = JSON.parse(localStorage.getItem("SavedQueryParams"));
    delete params.productDescription;
    this.router.navigate(['/start'], {queryParams : params});
  }
}
